import { Box, Grid, Paper, styled, Typography } from "@mui/material";

export const StyledFormContainer = styled(Box)({});

export const StyledMainFieldsPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const StyledStepContainer = styled(Box)({});

export const StyledStepTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
}));

export const StyledSectionContainer = styled(Box)(({ theme }) => ({
  margin: theme.spacing(4, 0),
}));

export const StyledSectionTitle = styled(Typography)({});

export const StyledFieldGridItem = styled(Grid)({});
